import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RequireNotUser = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (user) {
    return <Navigate to="/" />; // Chưa đăng nhập → chuyển hướng về Login
  }
  return children;
};

export default RequireNotUser;
